import { useEffect, useState } from "react";
import { ACTION_KEY, ACTION_SELECTED_ID_KEY, PARENT_ID_KEY } from "../config";
import {
  CRUDAction,
  CrudItems,
  CrudOptions,
} from "../components/Category/CrudMenu";
import {
  Action,
  ParentCrudItems,
  ParentCrudOptions,
} from "components/Category/ParentCrudMenu/ParentCrudMenu";
import { useDispatch, useSelector } from "react-redux";
import {
  selectActionID,
  selectActionKey,
  setActionID,
  setActionKey,
} from "reducers/redirect";
import {
  selectProgrammeId,
  selectRedirectUrl,
  setParentId,
} from "reducers/listPage";
import _ from "lodash";

export const useHandleParentActionFromStorage = <Data>(
  menuItems: ParentCrudItems<Data, ParentCrudOptions>,
  selectedId: React.ReactText | null,
  fromRowOption: boolean,
  dispatch: React.Dispatch<Action>,
  setTestRedirected?: React.Dispatch<
    React.SetStateAction<boolean | null | undefined>
  >
) => {
  const [redirected, setRedirected] = useState<boolean | null>();
  const actionKey = useSelector(selectActionKey);
  const actionID = useSelector(selectActionID);
  const dispatch_general = useDispatch();
  const programmeId = useSelector(selectProgrammeId);
  const redirect = useSelector(selectRedirectUrl);
  let redirectId: string | null = null;
  if (redirect) {
    const bracketIndex = _.indexOf(redirect, "(");

    // Get the substring of four characters after the bracket
    redirectId = redirect.substring(bracketIndex + 1, bracketIndex + 5);
  }
  useEffect(() => {
    const action = window.localStorage.getItem(ACTION_KEY) ?? actionKey;
    const parentID = window.localStorage.getItem(PARENT_ID_KEY);
    let finalSelectedId = selectedId;

    if (!action || !menuItems) {
      setRedirected(false);
      //setTestRedirected && setTestRedirected(false);
      return;
    }

    const storageSelectedId: string | null =
      window.localStorage.getItem(ACTION_SELECTED_ID_KEY) ?? actionID ?? null;

    // console.log("storageSelectedId: ", storageSelectedId);

    if (storageSelectedId && typeof storageSelectedId === "string") {
      finalSelectedId = parseInt(storageSelectedId);
    }

    if (!programmeId) return; //opt

    setRedirected(true);
    setTestRedirected && setTestRedirected(true);

    dispatch({
      type: "change_open_menu",
      payload: {
        parentCrudOptions: action as ParentCrudOptions,
        selectedId: redirectId ?? finalSelectedId,
        fromRowOption: fromRowOption
          ? fromRowOption
          : storageSelectedId
          ? true
          : false,
        //redirected: true,
      },
    });
    console.log(
      "@@@ setParentId(Number(finalSelectedId)): ",
      Number(finalSelectedId)
    );
    dispatch_general(setParentId(Number(finalSelectedId))); //opt

    dispatch_general(setActionID(null));
    dispatch_general(setActionKey(null));
    window.localStorage.removeItem(ACTION_KEY);
    // window.localStorage.removeItem(PARENT_ID_KEY);
    if (!parentID) {
      window.localStorage.removeItem(ACTION_SELECTED_ID_KEY);
    }
  }, [programmeId]);
  // }, [menuItems]); // NOTE: Commented this out as it caused the currentMenu to reset in the store when the menuItems changed. This meant that when redirecting and auto-opening a menu, it would sometimes not open the menu. So changed to just [] (initial render)

  return redirected;
};
